module.exports = __webpack_public_path__ + "media/images/front/products/standard/product_5-187b54baeeca637057549da7c6090a58.jpg";